import { render, staticRenderFns } from "./ApeEditor.vue?vue&type=template&id=2f996d9e"
import script from "./ApeEditor.vue?vue&type=script&lang=js"
export * from "./ApeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports